const NS = 'FeaturedPromoBlock';
const CLS = 'featuredPromoBlock';

import { mediaQuery } from '../../../../global/js/ara/mediaQuery';

export class FeaturedPromoBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.mediaQuery = mediaQuery;

		this.$colCard = this.$element.find(`.${CLS}-col--card`);
		this.$colImage = this.$element.find(`.${CLS}-col--image`);
		this.$card = this.$element.find(`.${CLS}-card`);

		// $(window).on('resize', _.debounce(() => {
		// 	this.adjustCardSize();
		// }, 50));

		// this.adjustCardSize();
	}

	adjustCardSize() {
		if(!this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.LG)) {
			if(this.$colCard.height() > this.$colImage.height()) {
				this.$colCard.css({
					height: `${this.$colImage.height()}px`
				});

				this.$card.css({
					height: `${this.$colImage.height()}px`
				});
			}
			else {
				this.$colCard.css({
					height: 'unset'
				});

				this.$card.css({
					height: `unset`
				});
			}
		}
		else {
			this.$colCard.css({
				height: 'unset'
			});

			this.$card.css({
				height: `unset`
			});
		}
	}
}
